/*
  Eingebettete Videos erst auf Klick laden.

  Hintergrund: Ein <iframe> im Seitenquelltext wird vom Browser sofort geladen,
  auch wenn er versteckt ist — `loading="lazy"` ändert daran nichts, das ist
  nachgemessen. Damit ginge schon beim Seitenaufruf eine Anfrage an die
  Mediathek, ohne dass jemand das Video sehen will.

  Deshalb steht im Seiteninhalt nur die Adresse als `data-video`. Der iframe
  entsteht erst, wenn jemand auf den Knopf drückt.

  Erwartetes Markup (im HTML einer Seite oder eines Blogbeitrags):

    <figure class="brand-video">
      <button type="button" class="brand-video__start"> … </button>
      <div class="brand-video__rahmen" data-video="https://…" data-titel="…"></div>
      <figcaption>…</figcaption>
    </figure>
*/
document.addEventListener('click', function (ereignis) {
  const knopf = ereignis.target.closest('.brand-video__start');
  if (!knopf) return;

  const block = knopf.closest('.brand-video');
  const rahmen = block && block.querySelector('.brand-video__rahmen');
  const quelle = rahmen && rahmen.dataset.video;
  if (!quelle || rahmen.querySelector('iframe')) return;

  const iframe = document.createElement('iframe');
  iframe.src = quelle;
  iframe.title = rahmen.dataset.titel || 'Video';
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('allow', 'fullscreen; picture-in-picture');
  rahmen.appendChild(iframe);

  block.classList.add('brand-video--offen');
  knopf.remove();
});
